import React, { useRef, useEffect, useState } from 'react';
import { HOTexts } from '../contexts/LangHO2';

import ProductHOOutline from './ProductHO-outline';
import ProductHOOutline2 from './ProductHO-outline2';
import ProductHOStatistics from './ProductHO-statistics';
import ProductHOAttack2 from './ProductHO-attack2';
import ProductHOMovement2 from './ProductHO-movement2';
import ProductHOPlatform2 from './ProductHO-platform2';
import ProductHOCustomer2 from './ProductHO-customer2';
import ProductHOPrize2 from './ProductHO-prize2';

function ProductHO({ lang = 'ko' }) {
  const certRef = useRef(null);
  const [certVisible, setCertVisible] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  useEffect(() => {
    const observer = new window.IntersectionObserver(
      ([entry]) => setCertVisible(entry.isIntersecting),
      { threshold: 0.3 }
    );
    if (certRef.current) observer.observe(certRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <div
      style={{
        minHeight: '100vh',
        background: '#0066CC',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%',         // 추가: 가로폭 100%
        maxWidth: '100vw',     // 추가: 최대 가로폭 제한
        overflowX: 'hidden',   // 추가: 가로 스크롤 방지
        padding: isMobile ? '0 10px' : '0'  // 모바일에서 좌우 패딩 추가
      }}
    >
      <h1 style={{
        color: '#fff',
        fontSize: isMobile ? '2rem' : '2.5rem',
        fontWeight: 700,
        letterSpacing: '-1px',
        margin: 0,
        marginBottom: isMobile ? 30 : 40,
        textAlign: 'center', // 가운데 정렬 추가
        padding: isMobile ? '0 20px' : '0',
        lineHeight: isMobile ? 1.3 : 1.2
      }}>
        {!isMobile && <><br /><br /><br /></>}{HOTexts.title[lang]}
        <br /><span style={{ color: '#ffb300' }}>{HOTexts.subtitle[lang]}</span>
      </h1>
      {/* <ProductHOOutline lang={lang} isMobile={isMobile}/> */}
      <ProductHOOutline2 lang={lang} isMobile={isMobile}/>
      {/* <ProductHOStatistics lang={lang} isMobile={isMobile}/> */}
      <ProductHOMovement2 lang={lang} isMobile={isMobile}/>
      <ProductHOAttack2 lang={lang} isMobile={isMobile}/>
      <ProductHOPlatform2 lang={lang} isMobile={isMobile}/>
      <ProductHOCustomer2 lang={lang} isMobile={isMobile}/>
      <ProductHOPrize2 lang={lang} isMobile={isMobile}/>
    </div>
  );
}

export default ProductHO;